import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, AlertTriangle, CalendarCheck, CheckCircle2, XCircle, MessageSquare, DollarSign, TrendingUp, Activity, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { StatCard, Loader, Pill } from "../components/common";

const FEED_ICON = { pain: AlertTriangle, missed: XCircle, message: MessageSquare };
const FEED_TONE = { pain: "danger", missed: "warning", message: "default" };

export default function CoachDashboard() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/coach/dashboard").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <Loader />;
  const s = data.summary;

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-heading text-5xl">Command Center</h1>
      <p className="text-secondary mt-1">Everything that needs your attention today.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-6">
        <StatCard label="Active Customers" value={s.active_customers} icon={Users} testId="stat-active" onClick={() => navigate("/coach/customers")} />
        <StatCard label="Needs Attention" value={s.needs_attention} icon={AlertTriangle} accent testId="stat-attention" />
        <StatCard label="Scheduled Today" value={s.scheduled_today} icon={CalendarCheck} testId="stat-scheduled" />
        <StatCard label="Completed Today" value={s.completed_today} icon={CheckCircle2} testId="stat-completed" />
        <StatCard label="Missed Workouts" value={s.missed_workouts} icon={XCircle} testId="stat-missed" />
        <StatCard label="Unread Messages" value={s.unread_messages} icon={MessageSquare} testId="stat-unread" onClick={() => navigate("/coach/messages")} />
        <StatCard label="MRR" value={`$${s.mrr}`} icon={DollarSign} accent testId="stat-mrr" />
        <StatCard label="Avg Completion" value={`${s.avg_completion}%`} icon={TrendingUp} testId="stat-completion" />
      </div>

      <h2 className="font-heading text-3xl mt-10">Priority Feed</h2>
      <div className="mt-4 space-y-2 max-w-3xl">
        {data.feed.length === 0 && <p className="text-tertiary text-sm">All caught up — nothing needs attention. 🎯</p>}
        {data.feed.map((f, i) => {
          const Icon = FEED_ICON[f.type] || Activity;
          return (
            <div key={i} data-testid="feed-item" className="card-surface rounded-xl p-4 flex items-center gap-4 hover:border-brand transition-all">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${f.type === "pain" ? "bg-brand/15" : f.type === "missed" ? "bg-warning/15" : "bg-white/5"}`}>
                <Icon className={`w-5 h-5 ${f.type === "pain" ? "text-brand" : f.type === "missed" ? "text-warning" : "text-secondary"}`} />
              </div>
              <div className="flex-1">
                <p className="font-semibold">{f.customer_name}</p>
                <p className="text-sm text-secondary">{f.text}</p>
              </div>
              <Pill tone={FEED_TONE[f.type]}>{f.type}</Pill>
              <button data-testid="feed-action" onClick={() => navigate(`/coach/customers/${f.customer_id}`)} className="text-brand hover:translate-x-1 transition-transform"><ArrowRight className="w-5 h-5" /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
